<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    title="课包下载"
    width="500px">
    <div>
      【{{ form && form.name }}】打包完成下载中{{ rate }}%，请稍后...
    </div>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button @click="handleClose">取消下载</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'PackageStatus',
  props: {
    form: Object,
    rate: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
    };
  },
  watch: {
    visible(vl) { this.dialogVisible = vl; },
    dialogVisible(vl) { this.$emit('update:visible', vl); },
  },
  mounted() {
    // this.$nextTick(()=>{
    //     this.init()
    // })
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit('success');
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/PackageStatus/index.vue